import { createRouter, createWebHistory } from 'vue-router';
import cookies from 'js-cookie';
import { store } from '@/store';
import AppLayout from '@/layout/admin/AppLayout.vue';
import UserAppLayout from '@/layout/user/AppLayout.vue';
import authMiddleware from '@/middleware/auth.js';

const adminCheck = (to, from, next) => {
    if (store.state?.role === 'admin') {
        next();
    } else {
        next({ name: 'unauthorized' });
    }
};

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            component: UserAppLayout,
            children: [
                {
                    path: '/',
                    name: 'home',
                    beforeEnter: (to, from, next) => {
                        store.dispatch('setUsers');
                        next();
                    },
                    component: () => import('@/views/pages/user/Index.vue')
                },
                {
                    path: '/profile',
                    name: 'profile',
                    beforeEnter: authMiddleware,
                    component: () => import('@/views/pages/user/profile/Index.vue')
                },
                {
                    path: '/p/:slug',
                    name: 'product-details',
                    beforeEnter: (to, from, next) => {
                        store.dispatch('setUsers');
                        next();
                    },
                    component: () => import('@/views/pages/user/p/Index.vue')
                },
                {
                    path: '/cart',
                    name: 'cart',
                    component: () => import('@/views/pages/user/cart/Index.vue'),
                    beforeEnter: authMiddleware
                },
                {
                    path: '/checkout',
                    name: 'checkout',
                    component: () => import('@/views/pages/user/checkout/Index.vue'),
                    beforeEnter: authMiddleware
                },
                {
                    path: '/order-details/:unique_id',
                    name: 'order-details',
                    component: () => import('@/views/pages/user/order-details/Index.vue'),
                    beforeEnter: authMiddleware
                },
                {
                    path: '/category/:slug/:sub?',
                    name: 'category-details',
                    component: () => import('@/views/pages/user/category/Index.vue')
                },
                {
                    path: '/article',
                    name: 'article',
                    component: () => import('@/views/pages/user/article/Index.vue'),
                },
                {
                    path: '/blog/:slug',
                    name: 'article-detail',
                    component: () => import('@/views/pages/user/a/Index.vue'),
                },
            ]
        },
        {
            path: '/app',
            component: AppLayout,
            beforeEnter: [authMiddleware, adminCheck],
            children: [
                {
                    path: '/app/dashboard',
                    name: 'app-dashboard',
                    component: () => import('@/views/pages/admin/Dashboard.vue')
                },
                {
                    path: '/app/settings',
                    name: 'app-settings',
                    component: () => import('@/views/pages/admin/settings/Index.vue')
                },
                {
                    path: '/app/onboarding/banners',
                    name: 'app-banners',
                    component: () => import('@/views/pages/admin/onboarding/banners/Index.vue')
                },
                {
                    path: '/app/onboarding/vouchers',
                    name: 'app-vouchers',
                    component: () => import('@/views/pages/admin/onboarding/vouchers/Index.vue')
                },
                {
                    path: '/app/customers',
                    name: 'app-customers',
                    component: () => import('@/views/pages/admin/customers/Index.vue')
                },
                {
                    path: '/app/categories',
                    name: 'app-categories',
                    component: () => import('@/views/pages/admin/products/categories/Index.vue')
                },
                {
                    path: '/app/sizes',
                    name: 'app-sizes',
                    component: () => import('@/views/pages/admin/products/sizes/Index.vue')
                },
                {
                    path: '/app/colors',
                    name: 'app-colors',
                    component: () => import('@/views/pages/admin/products/colors/Index.vue')
                },
                {
                    path: '/app/sub-categories/:category_id',
                    name: 'app-sub-categories',
                    component: () => import('@/views/pages/admin/products/categories/sub-categories/Index.vue')
                },
                {
                    path: '/app/products',
                    name: 'app-products',
                    component: () => import('@/views/pages/admin/products/products/Index.vue')
                },
                {
                    path: 'app/products-variants/:product_id/',
                    name: 'app-products-variants',
                    component: () => import('@/views/pages/admin/products/products/ProductVariant.vue')
                },
                {
                    path: '/app/transactions',
                    name: 'app-transactions',
                    component: () => import('@/views/pages/admin/transactions/Index.vue')
                },
                {
                    path: '/app/articles',
                    name: 'app-articles',
                    component: () => import('@/views/pages/admin/articles/Index.vue')
                },
            ]
        },

        {
            path: '/auth/login',
            name: 'login',
            component: () => import('@/views/pages/auth/Login.vue')
        },
        {
            path: '/auth/admin',
            name: 'login-admin',
            component: () => import('@/views/pages/auth/LoginAdmin.vue')
        },
        {
            path: '/auth/register',
            name: 'register',
            component: () => import('@/views/pages/auth/Register.vue')
        },
        {
            path: '/auth/activate-account/:token',
            name: 'activate-account',
            beforeEnter: authMiddleware,
            component: () => import('@/views/pages/auth/ActivateAccount.vue')
        },
        {
            path: '/:pathMatch(.*)*',
            name: 'notfound',
            component: () => import('@/views/pages/404.vue')
        },
        {
            path: '/unauthorized',
            name: 'unauthorized',
            component: () => import('@/views/pages/403.vue')
        }
    ]
});

export default router;